import { Button } from "@devhop/ui";
import {
  Calendar,
  CheckSquare,
  ChevronDown,
  FileText,
  Hash,
  Image,
  Mail,
  PenTool,
  Phone,
  Radio,
  Type,
} from "lucide-react";
import type { ReactNode } from "react";
import { FORM_FIELD_TYPE_DEFINITIONS } from "../constants/form-field-type-definitions";
import type { FormFieldType } from "../types/form-builder";

type FieldTypesPanelProps = {
  onAddField: (fieldType: FormFieldType) => void;
};

const iconByType: Record<FormFieldType, ReactNode> = {
  text: <Type className="h-4 w-4" />,
  textarea: <FileText className="h-4 w-4" />,
  number: <Hash className="h-4 w-4" />,
  date: <Calendar className="h-4 w-4" />,
  time: <Calendar className="h-4 w-4" />,
  datetime: <Calendar className="h-4 w-4" />,
  email: <Mail className="h-4 w-4" />,
  phone: <Phone className="h-4 w-4" />,
  select: <ChevronDown className="h-4 w-4" />,
  multiselect: <ChevronDown className="h-4 w-4" />,
  checkbox: <CheckSquare className="h-4 w-4" />,
  radio: <Radio className="h-4 w-4" />,
  file: <Image className="h-4 w-4" />,
  signature: <PenTool className="h-4 w-4" />,
};

export function FieldTypesPanel({ onAddField }: FieldTypesPanelProps) {
  return (
    <div
      className="rounded-xl border bg-card p-4"
      data-tourid="field-types-panel"
    >
      <h3 className="mb-4 font-semibold">ປະເພດຊ່ອງຂໍ້ມູນ</h3>
      <div className="space-y-2">
        {FORM_FIELD_TYPE_DEFINITIONS.map((def) => (
          <Button
            key={def.type}
            variant="outline"
            className="h-fit w-full justify-start"
            onClick={() => onAddField(def.type)}
          >
            <div className="flex items-center gap-2">
              {iconByType[def.type]}
              <div className="flex flex-col items-start">
                <span className="font-medium text-sm">{def.label}</span>
                <span className="text-muted-foreground text-xs">
                  {def.description}
                </span>
              </div>
            </div>
          </Button>
        ))}
      </div>
    </div>
  );
}
